import { createAction } from 'redux-actions';

export const UPDATE_MARQUEE = 'UPDATE MARQUEE';
export const UPDATE_FOOTER = 'UPDATE FOOTER';
export const UPDATE_PROMO_WELLS = 'UPDATE PROMO WELLS';
export const UPDATE_PRICING_DETAILS = 'UPDATE PRICING DETAILS';

const updateMarquee = createAction(
    UPDATE_MARQUEE,
    marquee => marquee
);

const updateFooter = createAction(
    UPDATE_FOOTER,
    footer => footer
);

const updatePromoWells = createAction(
    UPDATE_PROMO_WELLS,
    promoWells => promoWells
);

const updatePricingDetails = createAction(
    UPDATE_PRICING_DETAILS,
    pricingDetails => pricingDetails
);


export {
    updateMarquee,
    updateFooter,
    updatePromoWells,
    updatePricingDetails
};
